var STR_AU_ADDRESS = "<strong>Aarhus Universitet</strong><br />Nordre Ringgade 1<br />8000 Aarhus C<br />Tlf.: 8715 0000<br />E-mail: au@au.dk";
var STR_BUILDING = "Bygning";
var STR_BUILDINGS = "Bygninger";
var STR_DEPARTMENT = "Enhed";
var STR_DEPARTMENTS = "Enheder";
var STR_PEOPLE = "Personer";
var STR_NO_UNITS_FOUND = "Ingen enheder fundet.";
var STR_NO_PEOPLE_FOUND = "Ingen personer fundet.";
var STR_NO_UNITDATA_FOUND = "Ingen enhedsdata fundet.";
var STR_NO_PEOPLEDATA_FOUND = "Ingen persondata fundet.";
var STR_NO_BUILDINGS_FOUND_FOR_DEPARTMENT = "Der blev ikke fundet nogle bygninger tilknyttet den valgte enhed.";
var STR_LASTNAME = "Efternavn";
var STR_FIRSTNAME = "Fornavn";
var STR_OFFICE = "Kontor";
var STR_PHONE = "Tlf.";
var STR_EMAIL = "E-mail";
var STR_SHOW_PERSON_MAP = "Vis persondetaljer på kort";
var STR_PURE_LINK = "http://au.dk/da/";
var STR_OVERLAY_SELECT = "Vis...";
var STR_OVERLAY_REMOVE = "Fjern...";
var STR_NEAREST_LOCATION_DISTANCE = "Nærmeste lokation er {0}, som ligger {1} meter væk.";
var STR_FROM = "FRA";
var STR_TO = "TIL";
var STR_SELECT_BUILDING_BUS = "Vælg først én bygning for at få vist busstoppesteder i nærheden af bygningen.";
var STR_SHOW_TRAVEL = "Vis rejseinformation";
var STR_SELECT_TRAVEL = "Vælg rejseform";
var STR_DIRECTIONS = "Ruteforslag fra Rejseplanen";
var STR_OVERLAY_BUS = "Busstoppesteder";
var STR_ROUTE_ERROR = "Udfyld venligst både 'kommer fra' og 'skal til' og sørg for at en bygning, enhed eller person er markeret på kortet.";
var STR_REMOVE_ROUTE = "Fjern ruteplanlægning";
var STR_DETAILS_SHOW = "Vis detaljer";
var STR_DETAILS_HIDE = "Skjul detaljer";
var STR_NO_RESULTS = "Ingen resultater fundet.";
var STR_RESULTS_FOR = "Resultater for";
var STR_NO_PUBLIC_ROUTE = "Ingen ruteoplysninger fundet i Rejseplanen for det valgte tidspunkt.";

AU.maps.building = {
    baseURL: window.location.href.split('?')[0],
    departmentPath: '',
    constants: {
        BUILDING: -1,
        DEPARTMENT: -1,
        OVERLAY: -1,
        markerWidth: 34,
        markerHeight: 47,
        overlayMarkerWidth: 32,
        overlayMarkerHeight: 37,
        centerLat: 56.168995,
        centerLng: 10.203113,
        radii: {
            nearestBuilding: 100,
            nearestBus: 500,
            overlay: 2000
        }
    },
    data: {
        source: {
            stopsNearby: "//typo3.au.dk/maps/rejseplan.php?xml=http://xmlopen.rejseplanen.dk/bin/rest.exe/stopsNearby?coordX={0}&coordY={1}&maxRadius={2}&maxNumber={3}",
            departureBoard: "//typo3.au.dk/maps/rejseplan.php?xml=http://xmlopen.rejseplanen.dk/bin/rest.exe/departureBoard?id={0}&date={1}&time={2}&useBus=1",
            publicTransportRoute: "//typo3.au.dk/maps/rejseplan.php?xml=http://xmlopen.rejseplanen.dk/bin/rest.exe/trip?originId={0}&destId={1}&date={2}&time={3}&searchForArrival={4}",
            data: "//ipure.nfit.au.dk/web/xmltojson.php"
        },
        locations: []
    },
    center: null,
    currentLocation: null,
    startAddress: STR_AU_ADDRESS,
    markers: {
        icon: null,
        multiple: false,
        locations: [],
        overlays: []
    },
    map: null,
    mapContainer: null,
    options: {
        image: '',
        markerDrag: true,
        markerClick: true,
        clickPanTo: true,
        clickZoom: true,
        clickZoomLevel: 12,
        defaultZoomLevel: 17,
        mapWidth: '100%',
        mapHeight: '400',
        scrollWheel: true,
        draggable: true,
        clickable: true,
        streetView: true
    },
    querystrings: {
        building: AU.helpers.getQuerystring('b'),
        department: AU.helpers.getQuerystring('e'),
        person: AU.helpers.getQuerystring('p'),
        routeFrom: AU.helpers.getQuerystring('f'),
        routeTo: AU.helpers.getQuerystring('t'),
        routeMode: AU.helpers.getQuerystring('m', 1),
        overlay: AU.helpers.getQuerystring('o'),
        overlaySingle: AU.helpers.getQuerystring('os'),
        markers: AU.helpers.getQuerystring('markers')
    },
    setKeyEvents: function () {
        window.onkeydown = function (e) {
            var key = AU.helpers.getUnicodeKey(e);
            if (key === 16) { // Shift
                AU.maps.building.markers.multiple = true;
            }
            if (key === 70) { // F
                AU.maps.route.destinationFrom = true;
            }
            if (key === 84) { // T
                AU.maps.route.destinationTo = true;
            }
        };

        window.onkeyup = function () {
            AU.maps.building.markers.multiple = false;
            AU.maps.route.destinationFrom = false;
            AU.maps.route.destinationTo = false;
        };
    },
    setBuildingDropdowns: function () {
        $('#au_maps_buildings2').append($('<option/>').val('0').html(''));
        $('#au_maps_buildings3').append($('<option/>').val('0').html(''));
    },
    getDataPath: function () {
        var overlayQuery = "";
        if (typeof window.showOverlays !== "undefined") {
            for (var so = 0; so < window.showOverlays.length; so++) {
                overlayQuery += window.showOverlays[so].id + ",";
            }
            overlayQuery = overlayQuery.substring(0, overlayQuery.length - 1);
            overlayQuery = overlayQuery === "" ? "" : "&overlays=" + overlayQuery;
        }

        var langQuery = "?lang=" + (AU.pageLang === "da" ? "1" : "2");
        var departmentQuery = typeof window.department === "undefined" || window.department === "" ? "" : ("&department=" + window.department + '&overlays=false');
        return AU.maps.building.data.source.data + langQuery + overlayQuery + departmentQuery;
    },
    getData: function () {

        if (this.center !== null) {

            var dataFunc = function (data) {
                var b = AU.maps.building;
                // Alle lokationer indlæses som JSON
                b.data.locations = data.locations.sort(AU.maps.helpers.sortAlphaObj);
                if (data.constants.length === 1) {
                    b.constants.BUILDING = data.constants[0].building;
                    b.constants.DEPARTMENT = data.constants[0].department;
                    b.constants.OVERLAY = data.constants[0].overlay;
                }

                if ((AU.helpers.isMobileDevice() || typeof window.allowGeoLocation !== 'undefined') && navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        b.currentLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        b.init(b.currentLocation);
                    }, function () { // Hvis det ikke er accepteret at nuværende lokation må benyttes
                        b.init(b.center);
                    });
                } else { // Hvis enheden ikke understøtter geolocation
                    b.init(b.center);
                }
            };

            $.getJSON(this.getDataPath(), function (data) {
                dataFunc(data);
            });

            this.setAltLanguageHref(location.search);
        }
    },
    showPersonFunction: function (personHTML, buildingNumber, email, officePhone, address, auid, centerMap) {

        var b = AU.maps.building;
        b.disableRoutes();
        b.disableOverlays();

        if (typeof buildingNumber === "undefined") {
            AU.maps.geocodePersonAddress(b.map, b.options, b.markers.icon, address, centerMap, new google.maps.InfoWindow(), personHTML, function (marker, point, centerMap, infoWindow, windowContent) {

                b.markers.locations.push(marker);

                if (centerMap) {
                    b.map.setCenter(point);
                } else {
                    AU.maps.setBounds(b.map, [b.markers.locations]);
                }

                infoWindow.open(b.map, marker);
                infoWindow.setContent(windowContent);
            });
        } else {
            var building = b.getBuilding(buildingNumber);
            b.setBuildingMarker(building, false, false, centerMap, personHTML);
            if (b.markers.locations.length > 0) {
                google.maps.event.trigger(b.markers.locations[0], 'click');
            }
        }

        $('#au_maps_direct_link').attr('href', b.baseURL + '?p=' + auid);
        //$('#au_maps_direct_link').attr('href', b.baseURL + '?p=' + encodeURI(email));
        b.setAltLanguageHref('?p=' + auid);
        //b.setAltLanguageHref('?p=' + encodeURI(email));
        $('#au_maps_direct_link').show();
    },
    init: function (startPoint) {

        if (AU.pageLang !== "da") {

            STR_AU_ADDRESS = "<strong>Aarhus University</strong><br />Nordre Ringgade 1<br />DK-8000 Aarhus C<br />Denmark<br />Tel.: +45 8715 0000<br />Email: au@au.dk";
            STR_BUILDING = "Building";
            STR_BUILDINGS = "Buildings";
            STR_DEPARTMENT = "Unit";
            STR_DEPARTMENTS = "Units";
            STR_PEOPLE = "People";
            STR_NO_UNITS_FOUND = "No units found.";
            STR_NO_PEOPLE_FOUND = "No persons found.";
            STR_NO_UNITDATA_FOUND = "No unit data found.";
            STR_NO_PEOPLEDATA_FOUND = "No person data found";
            STR_NO_BUILDINGS_FOUND_FOR_DEPARTMENT = "No buildings associated with the selected unit.";
            STR_LASTNAME = "Last name";
            STR_FIRSTNAME = "First name";
            STR_OFFICE = "Office";
            STR_PHONE = "Phone";
            STR_EMAIL = "Email";
            STR_SHOW_PERSON_MAP = "Show person details on map";
            STR_PURE_LINK = "http://au.dk/en/";
            STR_OVERLAY_SELECT = "Show...";
            STR_OVERLAY_REMOVE = "Remove...";
            STR_NEAREST_LOCATION_DISTANCE = "Nearest location is {0}, {1} metres away.";
            STR_FROM = "FROM";
            STR_TO = "TO";
            STR_SELECT_BUILDING_BUS = "Please select one building to show the bus stops closest to the building.";
            STR_SHOW_TRAVEL = "Show travel information";
            STR_SELECT_TRAVEL = "Remove directions";
            STR_DIRECTIONS = "Route suggestions - Rejseplanen";
            STR_OVERLAY_BUS = "Bus stops";
            STR_ROUTE_ERROR = "Please fill out both 'travelling from' and 'travelling to' and make sure that a building, unit or person is selected on the map.";
            STR_REMOVE_ROUTE = "Remove directions";
            STR_DETAILS_SHOW = "Show details";
            STR_DETAILS_HIDE = "Hide details";
            STR_NO_RESULTS = "No results.";
            STR_RESULTS_FOR = "Results for";
            STR_NO_PUBLIC_ROUTE = "No route information available for the chosen date and time.";

        }

        AU.maps.building.departmentPath = typeof window.department === "undefined" || window.department === "" ? "" : ('&path=http://ipure.nfit.au.dk/current/' + (AU.pageLang === "da" ? 'da_DK' : 'en_GB') + '/lno/departments/' + window.department + '/people.xml');

        AU.maps.route.directionsService = new google.maps.DirectionsService();
        AU.maps.infoWindow = new google.maps.InfoWindow();
        AU.maps.geocoder = new google.maps.Geocoder();

        var obj = AU.maps.building;
        if (obj.mapContainer) {

            obj.map = AU.maps.create(obj.mapContainer, obj.options.mapWidth, obj.options.mapHeight, obj.options.defaultZoomLevel, startPoint, obj.options.scrollWheel, obj.options.draggable, obj.options.clickable, obj.options.streetView);

            // Rutvejledning initialiseres
            AU.maps.route.directionsDisplay = AU.maps.route.createDirectionObjects(obj.map, document.getElementById('au_maps_route_directionspanel'));

            // Finder alle lokationer til søgning
            var search = [];
            for (var i = 0; i < obj.data.locations.length; i++) {
                var loc = obj.data.locations[i];
                for (var n = 0; n < loc.names.length; n++) {
                    search.push({
                        id: loc.id,
                        label: loc.names[n].name,
                        value: loc.names[n].name,
                        type: loc.type
                    });
                }

                // Rutevejlednings-dropdown
                if (loc.type === obj.constants.BUILDING) {
                    $('#au_maps_buildings2').append($('<option/>').val(loc.id).html(loc.id));
                    $('#au_maps_buildings3').append($('<option/>').val(loc.id).html(loc.id));
                }
            }

            this.setAutoCompletes(search);

            // Dropdownlister til rutevejledning sorteres
            AU.maps.helpers.sortSelect('#au_maps_buildings2');
            AU.maps.helpers.sortSelect('#au_maps_buildings3');

            this.setRouteEvents();
            this.setMarkerEvents();
            this.setOverlayEvents();

            var qs = obj.querystrings;
            var clearOld, showContent, centerMap, building;

            // Hvis der er angivet en gyldig bygnings-querystring placeres en markør på baggrund af dette valg
            if (qs.building !== "") {
                building = this.getBuilding(decodeURI(qs.building));
                if (building !== null) {
                    clearOld = true;
                    showContent = true;
                    centerMap = true;
                    this.setBuildingMarker(building, clearOld, showContent, centerMap);
                }
            } else {
                // Hvis der er angivet mere end en bygning med b1, b2 osv.
                if (AU.helpers.getQuerystring('b1') !== "") {
                    obj.markers.multiple = true;
                    var count = 1;
                    var number = "";
                    do {
                        number = AU.helpers.getQuerystring('b' + count);
                        building = this.getBuilding(decodeURI(number));
                        if (building !== null) {
                            clearOld = false;
                            showContent = false;
                            centerMap = false;
                            this.setBuildingMarker(building, clearOld, showContent, centerMap);
                        }
                        count++;
                    } while (number !== "");
                    AU.maps.setBounds(obj.map, [obj.markers.locations]);
                }
            }

            if ((qs.department !== "" || window.department !== "") && qs.markers === "") {
                var departmentObj = this.getDepartment(qs.department === "" ? window.department : qs.department);
                if (departmentObj !== null) {
                    this.setDepartmentMarkers(departmentObj);
                }
            }

            if (qs.overlaySingle !== "") {
                var place = this.getOverlay(qs.overlaySingle);
                if (place !== null) {
                    this.setOverlayMarker(place, true, true, true, true);
                }
            }

            // Hvis der hverken er angivet en enhed eller querystring for bygning, enhed, person eller rute, placeres markøren i udgangspunktet
            if (qs.department === "" && window.department === "" && qs.building === "" && qs.overlaySingle === "" && !obj.markers.multiple && qs.person === "" && (qs.routeFrom === "" || qs.routeTo === "") && qs.markers === "") {
                this.clearMarkers(true, false);
                var options = obj.options;
                var marker = AU.maps.marker.add(obj.map, startPoint, this.markers.icon, options.markerDrag, options.markerClick, options.clickPanTo, options.clickZoom, options.clickZoomLevel, AU.maps.infoWindow, obj.startAddress, "");
                obj.markers.locations.push(marker);
                if (obj.currentLocation !== null) {
                    this.placeMarkerNearestToBuilding(startPoint, obj.data.locations);
                }
            }

            // Hvis der er angivet en gyldig person-querystring, placeres markøren ved den bygning (eller adresse), hvor personer har kontor
            if (qs.person !== "") {
                var person = decodeURI(qs.person);
                var exact = person.indexOf(' ') == -1;
                AU.helpers.getXML(AU.ipure.source.searchCrossSite + person + this.departmentPath + '&exact=' + (exact ? 'true' : 'false'), function (data) {
                    AU.maps.building.clearMarkers(true, false);
                    var people = AU.ipure.getPeople(data);
                    if (people.length === 1) {
                        AU.helpers.getXML(AU.ipure.source.searchDetailsCrossSite + people[0].url, function (data) {
                            AU.ipure.getPersonDetails(data, AU.maps.building.showPersonFunction);
                            $('#au_maps_building_content').hide();
                            AU.maps.building.disableRoutes();
                        });
                    } else if (people.length > 1) {
                        jQuery('#au_maps_autocomplete_people').val(person).focus().autocomplete('search');
                    }
                });
            }

            if (qs.overlay !== "") {
                var oSplit = qs.overlay.split(',');
                for (var os = 0; os < oSplit.length; os++) {
                    $('#au_maps_overlay_button_' + oSplit[os]).trigger('click');
                }
            }

            if (typeof window.showOverlays !== "undefined") {
                for (var so = 0; so < window.showOverlays.length; so++) {
                    if (window.showOverlays[so].pressed) {
                        $('#au_maps_overlay_button_' + window.showOverlays[so].id).trigger('click');
                    }
                }
            }


        }
    },
    setAutoCompletes: function (search) {
        // Lokationer
        var acLocOptions = {
            source: search,
            minLength: 3,
            autoFocus: true,
            select: function (event, ui) {
                var id = ui.item.id;

                var b = AU.maps.building;
                b.disableOverlays();

                if (ui.item.type === b.constants.BUILDING) {
                    AU.maps.building.setBuildingMarker(b.getBuilding(id), true, true, true);
                } else if (ui.item.type === b.constants.DEPARTMENT) {
                    AU.maps.building.setDepartmentMarkers(b.getDepartment(id));
                } else {
                    AU.maps.building.setOverlayMarker(b.getOverlay(id), true, true, true, true);
                    $('#au_maps_building_content').hide();
                }

                var trackerLink = '/virtual/maps/search/' + AU.helpers.rewriteLink(ui.item.value);
                AU.tracking.trackSingle(trackerLink);
            }
        };

        // Personsøgning
        var acPeopleOptions = {
            source: function (request, response) {

                var search = request.term;
                if (typeof String.prototype.trim === "function") {
                    search = search.trim();
                }

                AU.helpers.getXML(AU.ipure.source.searchCrossSite + encodeURI(search) + AU.maps.building.departmentPath, function (data) {
                    response(AU.ipure.getPeople(data));
                });
            },
            minLength: 3,
            autoFocus: true,
            select: function (event, ui) {
                AU.helpers.getXML(AU.ipure.source.searchDetailsCrossSite + ui.item.url, function (data) {
                    AU.maps.building.clearMarkers(true, false);
                    AU.ipure.getPersonDetails(data, AU.maps.building.showPersonFunction);
                    $('#au_maps_building_content').hide();
                    AU.maps.building.disableRoutes();

                    var trackerLink = '/virtual/maps/search/' + AU.helpers.rewriteLink(ui.item.value);
                    AU.tracking.trackSingle(trackerLink);
                });
            }
        };

        $('#au_maps_autocomplete_locations').autocomplete(acLocOptions);
        if (window.location.href.indexOf('mitstudie') == -1) {
            $('#au_maps_autocomplete_locations').focus();
        }
        $('#au_maps_autocomplete_people').autocomplete(acPeopleOptions);

    },
    setRouteEvents: function () {
        // Formularlogik
        $('#au_maps_route_from_building_radio').click(function () {
            $('#au_maps_route_from_destination_radio').prop('checked', false);
            $('#au_maps_route_from_location_radio').prop('checked', false);
            $('#au_maps_route_from_current_radio').prop('checked', false);
            $('#au_maps_route_from_container').show();
            $('#au_maps_route_from_building').show();
            $('#au_maps_route_from_destination').hide();
        });

        $('#au_maps_route_from_destination_radio').click(function () {
            $('#au_maps_route_from_building_radio').prop('checked', false);
            $('#au_maps_route_from_location_radio').prop('checked', false);
            $('#au_maps_route_from_current_radio').prop('checked', false);
            $('#au_maps_route_from_container').show();
            $('#au_maps_route_from_building').hide();
            $('#au_maps_route_from_destination').show();
        });

        $('#au_maps_route_from_location_radio').click(function () {
            $('#au_maps_route_from_destination_radio').prop('checked', false);
            $('#au_maps_route_from_building_radio').prop('checked', false);
            $('#au_maps_route_from_current_radio').prop('checked', false);
            $('#au_maps_route_from_container').hide();
        });

        $('#au_maps_route_from_current_radio').click(function () {
            $('#au_maps_route_from_destination_radio').prop('checked', false);
            $('#au_maps_route_from_location_radio').prop('checked', false);
            $('#au_maps_route_from_building_radio').prop('checked', false);
            $('#au_maps_route_from_container').hide();
        });

        $('#au_maps_route_to_building_radio').click(function () {
            $('#au_maps_route_to_destination_radio').prop('checked', false);
            $('#au_maps_route_to_location_radio').prop('checked', false);
            $('#au_maps_route_to_current_radio').prop('checked', false);
            $('#au_maps_route_to_container').show();
            $('#au_maps_route_to_building').show();
            $('#au_maps_route_to_destination').hide();
        });

        $('#au_maps_route_to_destination_radio').click(function () {
            $('#au_maps_route_to_building_radio').prop('checked', false);
            $('#au_maps_route_to_location_radio').prop('checked', false);
            $('#au_maps_route_to_current_radio').prop('checked', false);
            $('#au_maps_route_to_container').show();
            $('#au_maps_route_to_building').hide();
            $('#au_maps_route_to_destination').show();
        });

        $('#au_maps_route_to_location_radio').click(function () {
            $('#au_maps_route_to_destination_radio').prop('checked', false);
            $('#au_maps_route_to_building_radio').prop('checked', false);
            $('#au_maps_route_to_current_radio').prop('checked', false);
            $('#au_maps_route_to_container').hide();
        });

        $('#au_maps_route_to_current_radio').click(function () {
            $('#au_maps_route_to_destination_radio').prop('checked', false);
            $('#au_maps_route_to_location_radio').prop('checked', false);
            $('#au_maps_route_to_building_radio').prop('checked', false);
            $('#au_maps_route_to_container').hide();
        });

        var transport = $('#au_maps_route_travelmode');
        var travelContainer = $('#au_maps_travel_container');
        transport.change(function () {
            var id = parseInt($(this).val());
            if (id === 2) {
                $('#au_maps_route_public').show();
            } else {
                $('#au_maps_route_public').hide();
            }

            google.maps.event.trigger(AU.maps.building.map, 'resize');
            if (AU.maps.building.markers.locations.length > 0) {
                AU.maps.building.map.setCenter(AU.maps.building.markers.locations[0].position);
            }
        });

        // DateTimePicker knyttes til offentlig transport

        var now = new Date();
        var month = now.getMonth() + 1;
        var hours = now.getHours();
        var minutes = now.getMinutes();
        $('#au_maps_route_public_datetime').val(now.getDate() + '.' + (month < 10 ? '0' : '') + month + '.' + ('' + now.getFullYear()).substring(2) + ', ' + (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes);

        // Når der klikkes på rutevejledningsknappen undersøges der, hvilke radiobuttons, der er valgt, og en rute genereres på baggrund af dette
        $('form#au_maps_search_route').submit(function (e) {

            e.preventDefault();

            //AU.maps.building.disableOverlays();

            var selectedFrom = 1;
            var selectedTo = 1;

            if ($('#au_maps_route_from_destination_radio').is(':checked')) {
                selectedFrom = 2;
            }

            if ($('#au_maps_route_from_current_radio').is(':checked')) {
                selectedFrom = 3;
            }

            if ($('#au_maps_route_from_location_radio').is(':checked')) {
                selectedFrom = 4;
            }

            if ($('#au_maps_route_to_destination_radio').is(':checked')) {
                selectedTo = 2;
            }

            if ($('#au_maps_route_to_current_radio').is(':checked')) {
                selectedTo = 3;
            }

            if ($('#au_maps_route_to_location_radio').is(':checked')) {
                selectedTo = 4;
            }

            var travelSelect = $('#au_maps_route_travelmode').val();
            AU.maps.building.showRoute(selectedFrom, selectedTo, travelSelect, $('#au_maps_buildings2').val(), $('#au_maps_route_from_destination_text').val(), $('#au_maps_buildings3').val(), $('#au_maps_route_to_destination_text').val());

            var trackerLink = '/virtual/maps/route/' + travelSelect + '/' + selectedFrom + '/' + selectedTo;
            AU.tracking.trackSingle(trackerLink);
        });

        // Der tilføjes en listener til rutevisningen, således at ruteoplysningerne opdateres, når der trækkes i ruten
        google.maps.event.addListener(AU.maps.route.directionsDisplay, 'directions_changed', function () {
            var response = AU.maps.route.directionsDisplay.getDirections();
            if (response.routes.length > 0) {
                var route = response.routes[0];
                if (route.legs.length > 0) {
                    var start_address = route.legs[0].start_address;
                    var end_address = route.legs[0].end_address;
                    var travelMode = $('#au_maps_route_travelmode').val();
                    $('#au_maps_route_content_header').html(STR_FROM + ' <strong>' + start_address + '</strong> ' + STR_TO + ' <strong>' + end_address + '</strong>');
                    $('#au_maps_route_link').attr('href', AU.maps.building.baseURL + '?f=' + encodeURI(start_address) + '&t=' + encodeURI(end_address) + '&m=' + travelMode);
                }
            }
        });

        // Hvis der er angivet en rute indtegnes denne
        if (this.querystrings.routeFrom !== "" && this.querystrings.routeTo !== "") {

            var from = decodeURI(this.querystrings.routeFrom);
            var to = decodeURI(this.querystrings.routeTo);
            var selectedFrom;
            var selectedTo;

            // Vi finder først ud af, om der er indtastet et bygningsnummer eller om det er en adresse
            if (!isNaN(this.querystrings.routeFrom)) {
                var fromBuilding = AU.maps.building.getBuilding(this.querystrings.routeFrom);
                if (fromBuilding !== null) {
                    $('#au_maps_route_from_building_radio').trigger('click');
                    $('#au_maps_buildings2').val(fromBuilding.id);
                    selectedFrom = 1;
                }
            } else {
                $('#au_maps_route_from_destination_radio').trigger('click');
                $('#au_maps_route_from_destination_text').val(from);
                selectedFrom = 2;
            }

            if (!isNaN(this.querystrings.routeTo)) {
                var toBuilding = AU.maps.building.getBuilding(this.querystrings.routeTo);
                if (toBuilding !== null) {
                    $('#au_maps_route_to_building_radio').trigger('click');
                    $('#au_maps_buildings3').val(toBuilding.id);
                    selectedTo = 1;
                }
            } else {
                $('#au_maps_route_to_destination_radio').trigger('click');
                $('#au_maps_route_to_destination_text').val(to);
                selectedTo = 2;
            }

            var travelSelect = this.querystrings.routeMode; // Har en defaultværdi = 1
            $('#au_maps_route_travelmode').val(travelSelect);
            this.showRoute(selectedFrom, selectedTo, travelSelect, from, from, to, to);
            $('#au_maps_route_travelmode').trigger('change');
        }
    },
    showRoute: function (selectedFrom, selectedTo, travelSelect, fromBuildingVal, fromTextVal, toBuildingVal, toTextVal) {
        $('#au_maps_direct_link').hide();
        var currentMarker = selectedFrom === 4 || selectedTo === 4;
        this.clearMarkers(currentMarker ? false : true, false);
        var from;
        var to;
        var pos;
        var building;
        if (selectedFrom === 1) {
            building = AU.maps.building.getBuilding(fromBuildingVal);
            from = building === null ? null : new google.maps.LatLng(building.latitude, building.longitude);
        } else if (selectedFrom === 2) {
            from = fromTextVal;
        } else if (selectedFrom === 3) {
            if (this.currentLocation !== null) {
                from = new google.maps.LatLng(this.currentLocation.lat(), this.currentLocation.lng());
            } else {
                from = null;
            }
        } else {
            if (this.markers.locations.length > 0) {
                from = this.markers.locations[0].getPosition();
            } else {
                from = null;
            }
        }

        if (selectedTo === 1) {
            building = AU.maps.building.getBuilding(toBuildingVal);
            to = building === null ? null : new google.maps.LatLng(building.latitude, building.longitude);
        } else if (selectedTo === 2) {
            to = toTextVal;
        } else if (selectedTo === 3) {
            if (this.currentLocation !== null) {
                to = new google.maps.LatLng(this.currentLocation.lat(), this.currentLocation.lng());
            } else {
                to = null;
            }
        } else {
            if (this.markers.locations.length > 0) {
                to = this.markers.locations[0].getPosition();
            } else {
                to = null;
            }
        }

        var travelMode;
        // BICYCLING er p.t. kun tilgængelig i US of A...
        switch (travelSelect) {
            case "1":
                travelMode = google.maps.DirectionsTravelMode.DRIVING;
                break;
            case "2":
                travelMode = null; // Offentlig transport med Rejseplanens API
                break;
            case "3":
                travelMode = google.maps.DirectionsTravelMode.WALKING;
                break;
            default:
                travelMode = google.maps.DirectionsTravelMode.DRIVING;
        }

        if (to !== null && from !== null) {
            // Hvis vi har valgt offentlig transport
            if (travelMode === null) {
                var datetime;

                datetime = $('#au_maps_route_public_datetime').val();

                var split = datetime.split(',');
                if (split.length === 2) {
                    if (split[0].split('.').length === 3 && split[1].split(':').length === 2) {
                        var d = $.trim(split[0]);
                        var t = $.trim(split[1]);
                        var arrival = $('#au_maps_route_public_arrival').is(':checked') ? true : false;

                        var originPoint;
                        var destPoint;
                        // Kæft noget rod...
                        if (selectedFrom === 2) {
                            AU.maps.geocoder.geocode({
                                'address': from
                            }, function (results, status) {
                                if (status === google.maps.GeocoderStatus.OK) {
                                    originPoint = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                                    if (selectedTo === 2) {
                                        AU.maps.geocoder.geocode({
                                            'address': to
                                        }, function (results, status) {
                                            if (status === google.maps.GeocoderStatus.OK) {
                                                destPoint = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                                                AU.maps.building.getNearestBusStop(originPoint, destPoint, d, t, arrival);
                                            }
                                        });
                                    } else {
                                        destPoint = to;
                                        AU.maps.building.getNearestBusStop(originPoint, destPoint, d, t, arrival);
                                    }
                                }
                            });
                        } else {
                            originPoint = from;
                            if (selectedTo === 2) {
                                AU.maps.geocoder.geocode({
                                    'address': to
                                }, function (results, status) {
                                    if (status === google.maps.GeocoderStatus.OK) {
                                        destPoint = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                                        AU.maps.building.getNearestBusStop(originPoint, destPoint, d, t, arrival);
                                    }
                                });
                            } else {
                                destPoint = to;
                                AU.maps.building.getNearestBusStop(originPoint, destPoint, d, t, arrival);
                            }
                        }
                    }
                }
            } else {
                if (from === null || to === null) {
                    window.alert(STR_ROUTE_ERROR);
                } else {
                    AU.maps.route.calc(this.map, from, to, travelMode, AU.maps.route.directionsService, AU.maps.route.directionsDisplay);
                }
            }
        } else { // Hvis enten to eller from er undefined og der er valgt "nuværende lokation", som ikke er sat...
            if (selectedFrom === 3 || selectedTo === 3) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        AU.maps.building.currentLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        if (from === null) {
                            from = new google.maps.LatLng(AU.maps.building.currentLocation.lat(), AU.maps.building.currentLocation.lng());
                        } else { // to er undefined
                            to = new google.maps.LatLng(AU.maps.building.currentLocation.lat(), AU.maps.building.currentLocation.lng());
                        }
                        AU.maps.route.calc(AU.maps.building.map, from, to, travelMode, AU.maps.route.directionsService, AU.maps.route.directionsDisplay);
                    });
                }
            } else {
                window.alert(STR_ROUTE_ERROR);
                return false;
            }
        }

        if (travelMode !== null) {
            $('#au_maps_building_content').hide();
            $('#au_maps_route_content').show();
        }

        return true;
    },
    clickDelay: null,
    setMarkerEvents: function () {
        // Listener tilføjes kortet, så der kan klikkes på det for at placere en markør
        google.maps.event.addListener(AU.maps.building.map, 'click', function (p) {
            AU.maps.building.clickDelay = setTimeout(function () {
                var pointClick = new google.maps.LatLng(p.latLng.lat(), p.latLng.lng());
                AU.maps.building.disableOverlays();
                AU.maps.building.placeMarkerNearestToBuilding(pointClick, AU.maps.building.data.locations);
            }, 200);
        });
        google.maps.event.addListener(AU.maps.building.map, 'dblclick', function () {
            clearTimeout(AU.maps.building.clickDelay);
        });
        google.maps.event.addListener(AU.maps.building.map, 'dragend', function () {
            if ($('#au_maps_overlay_button_bus').hasClass('au_maps_overlay_pressed')) {
                AU.maps.building.setOverlays();
            }
        });
    },
    setOverlayEvents: function () {
        var overlayContainer = $('#au_maps_overlay_container');

        // Finder tilgængelige overlays fra datakilde
        var groupNames = [];
        var overlays = [];
        var locations = AU.maps.building.data.locations;
        for (var i = 0; i < locations.length; i++) {
            if (locations[i].type === AU.maps.building.constants.OVERLAY) {
                if ($.inArray(locations[i].groupname, groupNames) < 0) {
                    overlays.push({
                        id: locations[i].groupid,
                        name: locations[i].groupname
                    });
                    groupNames.push(locations[i].groupname);
                }
            }
        }

        var visibleOverlays = [];
        if (typeof window.showOverlays !== "undefined") {
            for (var so = 0; so < window.showOverlays.length; so++) {
                visibleOverlays.push(window.showOverlays[so].id);
            }
        }

        // Busstoppesteder er særlig og tilføjes manuelt
        if (typeof window.showOverlays === "undefined" || $.inArray('bus', visibleOverlays) > -1) {
            overlays.push({
                name: STR_OVERLAY_BUS,
                bus: true
            });
        }

        // Sorterer overlays og laver knapper
        overlays = overlays.sort(AU.maps.helpers.sortAlphaObj);
        for (var j = 0; j < overlays.length; j++) {

            overlayContainer.append($('<a />', {
                'id': 'au_maps_overlay_button_' + (typeof overlays[j].bus === "undefined" ? overlays[j].id : 'bus'),
                'class': typeof overlays[j].bus === "undefined" ? 'button small expanded disabled' : 'button small expanded disabled bus',
                'text': overlays[j].name,
                'href': '#'
            }));
        }

        // Ved klik ændres farven på knapper og overlays sættes
        $('.button', overlayContainer).click(function (e) {

            $(this).toggleClass('disabled');

            e.preventDefault();
            AU.maps.building.setOverlays();

            var trackerLink = '/virtual/maps/overlays/' + AU.helpers.rewriteLink($(this).text());
            AU.tracking.trackSingle(trackerLink);


        });

    },
    clearMarkers: function (normal, overlay) {
        if (normal) {
            for (var i = 0; i < AU.maps.building.markers.locations.length; i++) {
                AU.maps.building.markers.locations[i].setMap(null);
            }
            AU.maps.building.markers.locations = [];
        }

        if (overlay) {
            for (var j = 0; j < AU.maps.building.markers.overlays.length; j++) {
                AU.maps.building.markers.overlays[j].setMap(null);
            }
            AU.maps.building.markers.overlays = [];
        }
    },
    placeMarkerNearestToBuilding: function (point) {
        var clearOld = !AU.maps.building.markers.multiple;
        // Markøren placeres ved den nærmeste bygning, hvis en sådan er fundet inden for den angivne radius
        var nearestBuilding = this.getNearestBuilding(point, AU.maps.building.constants.radii.nearestBuilding);
        if (nearestBuilding !== null) {
            var showContent = true;
            var centerMap = true;
            // Hvis "genvejsfunktionaliteten" til ruteplanlægning er anvendt, aktiveres ruteplanlægningsformularen
            if (AU.maps.route.destinationFrom || AU.maps.route.destinationTo) {
                if (AU.maps.route.destinationFrom) {
                    $('#au_maps_route_from_building_radio').trigger('click');
                    $('#au_maps_buildings2').val(nearestBuilding.id);
                    if ($('#au_maps_route_to_building_radio').is(':checked')) {
                        $('#au_maps_route_button').trigger('click');
                    }
                }

                if (AU.maps.route.destinationTo) {
                    $('#au_maps_route_to_building_radio').trigger('click');
                    $('#au_maps_buildings3').val(nearestBuilding.id);
                    if ($('#au_maps_route_from_building_radio').is(':checked')) {
                        $('#au_maps_route_button').trigger('click');
                    }
                }
                $('#au_maps_route_travelmode').val('1'); // Default'er til bil
                $('#au_maps_route_travelmode').trigger('change');
            } else {
                AU.maps.building.setBuildingMarker(nearestBuilding, clearOld, showContent, centerMap);
            }
            // Hvis der ikke er fundet en bygning inden for radius placeres blot en markør på stedet
        } else {
            var address = "";
            if (clearOld) {
                this.clearMarkers(true, false);
            }

            var options = this.options;
            var marker = AU.maps.marker.add(this.map, point, AU.maps.building.markers.icon, options.markerDrag, options.markerClick, options.clickPanTo, options.clickZoom, options.clickZoomLevel, AU.maps.infoWindow, address, nearestBuilding !== null ? nearestBuilding.number : "");
            this.markers.locations.push(marker);
            this.map.setCenter(point);
        }
    },
    setOverlays: function () {
        this.clearMarkers(true, true);
        var buttons = $('#au_maps_overlay_container .button:not(.disabled)');

        // Vi fjerner overlayelementer i indholdsvisningen...
        var contentContainer = $('#au_maps_building_content');
        contentContainer.empty();
        $('.au_maps_overlay_content', contentContainer).remove();

        var count = 0;
        $.each(buttons, function () {
            var text = $(this).text();

            // ...og tilføjer dem igen!
            var overlayContent = $('<div />', {
                'class': 'au_maps_overlay_content',
                'id': 'au_maps_overlay_content_' + count
            });

            if ($(this).hasClass('bus')) {
                overlayContent.addClass('au_maps_overlay_bus_content');
            }

            if (count === 0) {
                overlayContent.prependTo(contentContainer);
            } else {
                $('#au_maps_overlay_content_' + parseInt(count - 1)).after(overlayContent);
            }

            $('<h1 />', {
                html: text
            }).appendTo(overlayContent);

            var list = $('<ul />').appendTo(overlayContent);

            // Sætter overlaymarkører og genererer en liste, hvor der kan klikkes på de enkelte lokaliteter
            var locations = AU.maps.building.data.locations;
            for (var n = 0; n < locations.length; n++) {
                var place = locations[n];
                if (place.type === AU.maps.building.constants.OVERLAY && place.groupname === text) {
                    AU.maps.building.setOverlayMarker(place, false, false, false, false);
                    var placeLink = $('<a />', {
                        'class': 'au_maps_overlay_list',
                        'href': place.url,
                        'text': place.names[0].name,
                        'id': 'au_maps_overlay_list_' + n + '_' + place.id
                    });

                    list.append($('<li />', {
                        'html': placeLink
                    }));
                }
            }

            count++;
        });

        $('.au_maps_overlay_list').click(function (e) {

            e.preventDefault();

            var id = $(this).attr('id');
            var split = id.split('_');
            if (split.length === 6) {
                id = split[5];
                for (var m = 0; m < AU.maps.building.markers.overlays.length; m++) {
                    var marker = AU.maps.building.markers.overlays[m];
                    if (marker.get('id') === id) {
                        google.maps.event.trigger(marker, 'click');
                        $('.au_maps_overlay_list').css('font-weight', 'normal');
                        $(this).css('font-weight', 'bold');
                    }
                }
            }
        });

        // Ved klik på busstoppesteder indlæses data fra Rejseplanen
        var bus = false;
        if (!$('.button.bus').hasClass('disabled')) {
            bus = true;
            var id = $('.button.bus').attr('id');
            var split = id.split('au_maps_overlay_button_');
            if (split.length === 2) {
                var busIndex = split[1] - 1;
                this.getStopsNearby(this.map.getCenter(), 30, busIndex, $('.au_maps_overlay_bus_content'));
            }
        }

        // getStopsNearby kører asynkront, så bounds vil blive sat INDEN data er hentet - derfor tjek for bus
        if (!bus) {
            this.setBoundsForOverlays();
        }

        contentContainer.show();

        this.disableRoutes();

        return buttons.length;
    },
    setBoundsForOverlays: function () {
        var bounds_markers = [];
        var obj = AU.maps.building;
        for (var o = 0; o < obj.markers.overlays.length; o++) {

            var boundsFixPosition = obj.markers.locations.length > 0 ? obj.markers.locations[0].position : (obj.currentLocation === null ? obj.map.getCenter() : obj.currentLocation);

            if (AU.maps.helpers.getDistanceBetweenPoints(obj.markers.overlays[o].position, boundsFixPosition) <= obj.constants.radii.overlay || obj.markers.overlays[o].get('groupid') === 0) {
                bounds_markers.push(obj.markers.overlays[o]);
            }
        }

        if (bounds_markers.length > 1) {
            AU.maps.setBounds(obj.map, [bounds_markers]);
        } else {
            if (bounds_markers.length === 1) {
                obj.map.setCenter(bounds_markers[0].position);
            } else {
                if (obj.markers.overlays.length > 0) {
                    AU.maps.setBounds(obj.map, [obj.markers.overlays]);
                }
            }
        }
    },
    setBuildingMarker: function (building, clearOld, showContent, centerMap, windowContent) {
        if (clearOld) {
            this.clearMarkers(true, false);
        }

        var point = new google.maps.LatLng(building.latitude, building.longitude);
        if (typeof windowContent === "undefined" && typeof building.address !== "undefined") {
            windowContent = "<p><strong>" + building.address + "</strong></p>";
        }

        var marker = AU.maps.marker.add(this.map, point, this.markers.icon, this.options.markerDrag, this.options.markerClick, this.options.clickPanTo, this.options.clickZoom, this.options.clickZoomLevel, AU.maps.infoWindow, windowContent, building.names[0].name);
        this.markers.locations.push(marker);

        if (centerMap) {
            this.map.setCenter(point);
        }

        if (showContent) {
            var dSource = AU.ipure.source.searchDetailsCrossSite + "./buildings/" + building.id + "/departments.xml";
            var pSource = AU.ipure.source.searchDetailsCrossSite + "./buildings/" + building.id + "/people.xml";
            AU.maps.building.generateContentHTML(this.markers.multiple ? building.number : 0, [], dSource, pSource, building.names[0].name + (typeof building.address === "undefined" ? "" : " - " + building.address), false);
            $('#au_maps_buildings2').val(building.id);
            $('#au_maps_buildings3').val(building.id);
        }

        if (this.markers.locations.length === 1) {
            $('#au_maps_direct_link').attr('href', this.baseURL + '?b=' + building.id);
            this.setAltLanguageHref('?b=' + building.id);
        } else {
            if ($('#au_maps_direct_link').length > 0) {
                var oldHref = $('#au_maps_direct_link').attr('href');
                oldHref = oldHref.replace('b=', 'b1=');
                oldHref += "&b" + this.markers.locations.length + "=" + building.id;
                $('#au_maps_direct_link').attr('href', oldHref);
                if (oldHref.indexOf('?') > -1) {
                    this.setAltLanguageHref('?' + oldHref.split('?')[1]);
                }
            }
        }
        $('#au_maps_direct_link').show();
    },
    setOverlayMarker: function (place, clearOld, centerMap, openWindow, single) {
        if (clearOld) {
            this.clearMarkers(true, false);
        }

        var point = new google.maps.LatLng(place.latitude, place.longitude);

        var windowContent = typeof place.text === "undefined" ? ("<p><strong>" + (place.url === "" ? "" : "<a href=\"" + (place.url === '' ? '#' : place.url) + "\">") + place.names[0].name + (typeof place.url === "undefined" ? "" : "</a>") + "</strong></p>") : place.text;

        var icon;
        if (place.icon.indexOf('generic') === -1) {
            icon = new google.maps.MarkerImage(place.icon, null, null, null, new google.maps.Size(AU.maps.building.constants.overlayMarkerWidth, AU.maps.building.constants.overlayMarkerHeight));
        } else {
            icon = new google.maps.MarkerImage(place.icon, null, null, null, new google.maps.Size(AU.maps.building.constants.markerWidth, AU.maps.building.constants.markerHeight));
        }

        var marker = AU.maps.marker.add(this.map, point, icon, this.options.markerDrag, this.options.markerClick, this.options.clickPanTo, this.options.clickZoom, this.options.clickZoomLevel, AU.maps.infoWindow, windowContent, place.names[0].name, place.id);

        if (single) {
            this.markers.locations.push(marker);
            $('#au_maps_direct_link').attr('href', this.baseURL + '?os=' + place.id);
            this.setAltLanguageHref('?os=' + place.id);
            $('#au_maps_direct_link').show();
        } else {
            marker.set('groupid', parseInt(place.groupid));
            this.markers.overlays.push(marker);
            $('#au_maps_direct_link').hide();
        }

        if (openWindow) {
            google.maps.event.trigger(marker, 'click');
        }

        if (centerMap) {
            this.map.panTo(marker.getPosition());
            this.map.setZoom(this.options.defaultZoomLevel);
        }


    },
    setDepartmentMarkers: function (department) {
        AU.helpers.getXML(AU.ipure.source.searchDetailsCrossSite + department.departmentsdetails, function (data) {
            var clearOld = false;
            var showContent = false;
            var centerMap = false;

            var addressNode = $(data).find('address');
            var street = addressNode.attr('street');
            var zip = addressNode.attr('zip');
            var city = addressNode.attr('city');
            var address = street + ", " + zip + " " + city;

            var departmentsNode = $(data).find('departments');
            var peopleNode = $(data).find('people');
            var departmentsSource = typeof departmentsNode.attr('external') === "undefined" ? "" : (AU.ipure.source.searchDetailsCrossSite + department.departmentsdetails.replace('details.xml', departmentsNode.attr('external')));
            var peopleSource = typeof peopleNode.attr('external') === "undefined" ? "" : (AU.ipure.source.searchDetailsCrossSite + department.departmentsdetails.replace('details.xml', peopleNode.attr('external')));
            var buildingNode = $(data).find('building');
            var buildings = [];

            // Bygninger ligger ikke direkte som en datakilde
            for (var i = 0; i < buildingNode.length; i++) {
                var building = AU.maps.building.getBuilding($(buildingNode[i]).attr('number'));
                if (building !== null) {
                    buildings.push(building);
                }
            }

            // Løber alle bygninger igennem og placerer markører
            if (buildings.length > 0) {
                for (var k = 0; k < buildings.length; k++) {
                    AU.maps.building.setBuildingMarker(buildings[k], clearOld, showContent, centerMap);
                }
                AU.maps.setBounds(AU.maps.building.map, [AU.maps.building.markers.locations]);
            } else {
                // Hvis vi ikke finder nogle bygninger, AU.maps.geocoder vi på baggrund af enhedens adresse
                AU.maps.geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        var point = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                        var options = AU.maps.building.options;
                        var marker = AU.maps.marker.add(AU.maps.building.map, point, AU.maps.building.markers.icon, options.markerDrag, options.markerClick, options.clickPanTo, options.clickZoom, options.clickZoomLevel, AU.maps.infoWindow, "", "");
                        AU.maps.building.markers.locations.push(marker);
                        AU.maps.building.map.setCenter(point);
                    }
                });
            }

            AU.maps.building.generateContentHTML(0, buildings, departmentsSource, peopleSource, department.names[0].name, true);
            $('#au_maps_direct_link').attr('href', AU.maps.building.baseURL + '?e=' + (typeof department.id === "undefined" ? department.name : department.id));
            AU.maps.building.setAltLanguageHref('?e=' + (typeof department.id === "undefined" ? department.name : department.id));
            $('#au_maps_direct_link').show();


        });
    },
    generateContentHTML: function (count, buildings, departmentsSource, peopleSource, headline, isDepartment) {
        var contentContainer = $('#au_maps_building_content');
        if (count === 0) {
            contentContainer.children().each(function () {
                $(this).remove();
            });
        }
        $('<h1 />', {
            id: 'au_maps_building_content_header_' + count,
            html: headline
        }).appendTo(contentContainer);

        $('<h2 />', {
            id: 'au_maps_content_people_headline_' + count,
            'class': 'au_maps',
            html: STR_PEOPLE
        }).appendTo(contentContainer);

        $('<div />', {
            'class': 'au_maps_building_content_people',
            id: 'au_maps_building_content_people_' + count
        }).appendTo(contentContainer);

        var peopleHTML;
        if (peopleSource !== "") {
            AU.helpers.getXML(peopleSource, function (data) {
                var people = AU.ipure.getPeople(data);
                if (people.length > 0) {
                    if (people.length <= 500) {
                        AU.maps.building.setPeopleTable(count, people, $('#au_maps_building_content_people_' + count), isDepartment);
                    } else {
                        $('#au_maps_content_people_headline_' + count).hide();
                    }
                } else {
                    peopleHTML = "<p>" + STR_NO_PEOPLE_FOUND + "</p>";
                    $(peopleHTML).appendTo($('#au_maps_building_content_people_' + count));
                }


            });
        } else {
            peopleHTML = "<p>" + STR_NO_PEOPLEDATA_FOUND + "</p>";
            $(peopleHTML).appendTo($('#au_maps_building_content_people_' + count));
        }

        var buildingsHTML;
        if (buildings.length > 0) {

            $('<h2 />', {
                'class': 'au_maps',
                html: STR_BUILDINGS
            }).appendTo(contentContainer);

            $('<div />', {
                'class': 'au_maps_building_content_buildings',
                id: 'au_maps_building_content_buildings_' + count
            }).appendTo(contentContainer);

            buildingsHTML = "<ul>";
            // Pas på! Der kan komme bygninger ud, som IKKE har GPS-koordinater.
            for (var i = 0; i < buildings.length; i++) {
                if (typeof buildings[i].latitude !== "undefined" && typeof buildings[i].longitude !== "undefined") {
                    buildingsHTML += "<li><a class=\"au_maps_buildinglist\" href=\"" + this.baseURL + "?b=" + buildings[i].id + "\">" + STR_BUILDING + " " + buildings[i].id + "</a></li>";
                }
            }
            buildingsHTML += "</ul>";
        } else {
            buildingsHTML = "<p>" + STR_NO_BUILDINGS_FOUND_FOR_DEPARTMENT + "</p>";
        }

        $(buildingsHTML).appendTo('#au_maps_building_content_buildings_' + count);

        $.each($('.au_maps_buildinglist'), function (i, b) {
            $(b).click(function (e) {
                google.maps.event.trigger(AU.maps.building.markers.locations[i], 'click');
                $('.au_maps_buildinglist').css('font-weight', 'normal');
                $(this).css('font-weight', 'bold');

                e.preventDefault();
            });
        });

        $('<h2 />', {
            'class': 'au_maps',
            html: STR_DEPARTMENTS
        }).appendTo(contentContainer);

        $('<div />', {
            'class': 'au_maps_building_content_departments',
            id: 'au_maps_building_content_departments_' + count
        }).appendTo(contentContainer);

        var departmentsHTML;
        if (departmentsSource !== "") {
            AU.helpers.getXML(departmentsSource, function (data) {
                var departments = AU.maps.building.getDepartments(data);
                if (departments.length > 0) {
                    departmentsHTML = "<ul>";
                    for (var i = 0; i < departments.length; i++) {
                        departmentsHTML += "<li><a href=\"" + AU.maps.building.baseURL + '?e=' + departments[i].id + "\">" + departments[i].name + "</a></li>";
                    }
                    departmentsHTML += "</ul>";
                } else {
                    departmentsHTML = "<p>" + STR_NO_UNITS_FOUND + "</p>";
                }
                $(departmentsHTML).appendTo($('#au_maps_building_content_departments_' + count));


            });
        }
        else {
            departmentsHTML = "<p>" + STR_NO_UNITDATA_FOUND + "</p>";
            $(departmentsHTML).appendTo($('#au_maps_building_content_departments_' + count));
        }

        contentContainer.show();
        this.disableRoutes();


    },
    setPeopleTable: function (count, people, element, isDepartment, incomplete) {
        var tableContent = "<thead><tr><th>" + STR_LASTNAME + "</th><th>" + STR_FIRSTNAME + "</th>";

        if (!isDepartment) {
            tableContent += "<th>" + STR_OFFICE + "</th>";
        }
        if (typeof incomplete !== "undefined") {
            tableContent += "<th>" + STR_PHONE + "</th><th>" + STR_EMAIL + "</th>";
        }
        tableContent += "<th>&nbsp;</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody></tbody>";

        $('<table />', {
            'class': 'au_maps_people_table',
            'id': 'au_maps_people_table_' + count,
            'html': tableContent
        }).appendTo(element);


        var peopleHTML = "";
        for (var i = 0; i < people.length; i++) {
            peopleHTML += "<tr><td>" + people[i].lastname + "</td><td>" + people[i].firstname + "</td>";
            if (!isDepartment) {
                peopleHTML += "<td>" + (typeof people[i].room === "undefined" ? "-" : people[i].room) + "</td>";
            }
            if (typeof incomplete !== "undefined") {
                peopleHTML += "<td>" + (typeof people[i].phone === "undefined" ? "-" : people[i].phone) + "</td>";
                peopleHTML += typeof people[i].email === "undefined" ? "<td>-</td>" : "<td><a href=\"" + STR_PURE_LINK + people[i].email + "\">" + people[i].email + "</a></td>";
            }

            //peopleHTML += "<td class=\"alignright\"><a href=\"" + this.baseURL + "?p=" + people[i].employeeId + "\">" + STR_SHOW_PERSON_MAP + "</a></td></tr>";
            peopleHTML += "<td class=\"alignright\"><a href=\"" + this.baseURL + "?p=" + encodeURI(people[i].firstname + ' ' + people[i].lastname) + "\">" + STR_SHOW_PERSON_MAP + "</a></td></tr>";
        }

        $(peopleHTML).appendTo($('#au_maps_people_table_' + count));

        $('#au_maps_people_table_' + count).dataTable({
            'bPaginate': true,
            'bLengthChange': false,
            'bFilter': true,
            'bSort': true,
            'bInfo': false,
            'bAutoWidth': true,
            'sPaginationType': 'full_numbers',
            'oLanguage': {
                'sSearch': 'Filtrér',
                'sZeroRecords': 'Intet resultat fundet.'
            }
        });


    },
    getStopsNearby: function (center, max, busIndex, list) {
        if (typeof max === "undefined") {
            max = 30;
        }

        var x = AU.maps.helpers.convertFromLatLng(center.lat());
        var y = AU.maps.helpers.convertFromLatLng(center.lng());

        var source = this.data.source.stopsNearby.replace('{0}', x).replace('{1}', y).replace('{2}', this.constants.radii.nearestBus).replace('{3}', max);
        AU.helpers.getXML(source, function (data) {
            var locations = $(data).find('StopLocation');
            for (var i = 0; i < locations.length; i++) {
                var point = new google.maps.LatLng(AU.maps.helpers.convertToLatLng($(locations[i]).attr('y')), AU.maps.helpers.convertToLatLng($(locations[i]).attr('x')));
                var id = $(locations[i]).attr('id');
                var name = $(locations[i]).attr('name');
                var distance = $(locations[i]).attr('distance');
                var windowContent = "<p><strong>" + name + "</strong><br />";
                windowContent += distance + " m.<br />";
                windowContent += "<a href=\"\" onclick=\"AU.maps.building.showDepartureInfo(" + id + ", '" + name + "'); return false;\">" + STR_SHOW_TRAVEL + "</a></p>";
                var markerDrag = false;
                var options = AU.maps.building.options;
                var busIcon = new google.maps.MarkerImage('https://cdn.au.dk/2011/maps/graphics/marker_bus.png', null, null, null, new google.maps.Size(AU.maps.building.constants.overlayMarkerWidth, AU.maps.building.constants.overlayMarkerHeight));
                var marker = AU.maps.marker.add(AU.maps.building.map, point, busIcon, markerDrag, options.markerClick, options.clickPanTo, options.clickZoom, options.clickZoomLevel, AU.maps.infoWindow, windowContent, name, 'bus' + i);
                AU.maps.building.markers.overlays.push(marker);

                if (list !== "undefined") {

                    var placeLink = $('<a />', {
                        'class': 'au_maps_overlay_list',
                        'href': '',
                        'text': name,
                        'id': 'au_maps_overlay_list_' + busIndex + '_bus' + i
                    });

                    $('ul', list).append($('<li />', {
                        'html': placeLink
                    }));
                }
            }

            $('.au_maps_overlay_list').click(function (e) {
                var id = $(this).attr('id');
                var split = id.split('_');
                if (split.length === 6) {
                    id = split[5];
                    for (var m = 0; m < AU.maps.building.markers.overlays.length; m++) {
                        var marker = AU.maps.building.markers.overlays[m];
                        if (marker.get('id') === id) {
                            google.maps.event.trigger(marker, 'click');
                            $('.au_maps_overlay_list').css('font-weight', 'normal');
                            $(this).css('font-weight', 'bold');
                        } else {
                            marker.set('bounce', false);
                            marker.setAnimation(null);
                        }
                    }
                }

                e.preventDefault();
            });

            AU.maps.building.setBoundsForOverlays();


        });
    },
    showDepartureInfo: function (id, name) {
        // Vi fjerner alle elementer i indholdsvisningen...
        var contentContainer = $('#au_maps_building_content');
        contentContainer.children().each(function () {
            $(this).remove();
        });

        var overlayContent = $('<div />', {
            'class': 'au_maps_overlay_content'
        });

        // ...og bygger op på ny!
        $('<h1 />', {
            id: 'au_maps_building_content_header',
            html: name
        }).appendTo(overlayContent);

        var source = this.data.source.departureBoard.replace('{0}', id).replace('{1}', AU.maps.helpers.getCurrentDate()).replace('{2}', AU.maps.helpers.getCurrentTime());
        AU.helpers.getXML(source, function (data) {
            var departureHTML = "<ul>";
            var departures = $(data).find('Departure');
            for (var i = 0; i < departures.length; i++) {
                var time = $(departures[i]).attr('time');
                var name = $(departures[i]).attr('name');
                var direction = $(departures[i]).attr('direction');
                var journeyDetailRef = $(departures[i]).find('JourneyDetailRef');
                var ref = journeyDetailRef.attr('ref');
                departureHTML += "<li><a href=\"\" class=\"au_maps_list_busroute\" onclick=\"AU.maps.building.showBusRouteByMarkers('" + ref + "'); return false;\">" + time + " - " + name + ", " + direction + "</a></li>";
            }
            departureHTML += "</ul>";
            $(departureHTML).appendTo(overlayContent);
            overlayContent.appendTo(contentContainer);
            $('.au_maps_list_busroute').click(function () {
                $('.au_maps_list_busroute').css('font-weight', 'normal');
                $(this).css('font-weight', 'bold');
            });


        });

        $('#au_maps_content_trigger').trigger('click');
        AU.maps.building.disableRoutes();
    },
    departureTimes: null,
    showBusRouteByMarkers: function (url) {
        this.clearMarkers(false, true);
        $('#au_maps_overlay_container .button').addClass('disabled');
        this.departureTimes = [];
        AU.helpers.getXML("//typo3.au.dk/maps/rejseplan.php?xml=" + url, function (data) {
            var stopsXML = $(data).find('Stop');
            $.each(stopsXML, function (i, s) {
                var lat = AU.maps.helpers.convertToLatLng($(s).attr('y'));
                var lng = AU.maps.helpers.convertToLatLng($(s).attr('x'));
                var name = $(s).attr('name');
                var depTime = $(s).attr('depTime');
                var point = new google.maps.LatLng(lat, lng);
                var options = AU.maps.building.options;
                var busIcon = new google.maps.MarkerImage('https://cdn.au.dk/2011/maps/graphics/marker_bus.png', null, null, null, new google.maps.Size(AU.maps.building.constants.overlayMarkerWidth, AU.maps.building.constants.overlayMarkerHeight));
                var marker = AU.maps.marker.add(AU.maps.building.map, point, busIcon, options.markerDrag, options.markerClick, options.clickPanTo, options.clickZoom, options.clickZoomLevel, AU.maps.infoWindow, name + (typeof depTime === "undefined" ? '' : ' - ' + depTime), name + (typeof depTime === "undefined" ? '' : ' - ' + depTime));
                AU.maps.building.markers.overlays.push(marker);
                if (typeof depTime !== "undefined") {
                    AU.maps.building.departureTimes.push(depTime);
                }
            });

            AU.maps.setBounds(AU.maps.building.map, [AU.maps.building.markers.overlays]);
            AU.maps.building.showBusCurrentLocation();
            setInterval(AU.maps.building.showBusCurrentLocation, 60000); // Kaldes en gang i minuttet
        });
    },
    showBusCurrentLocation: function () {
        var closest;
        var found = false;
        for (var i = 0; i < AU.maps.building.departureTimes.length; i++) {
            AU.maps.building.markers.overlays[i].setAnimation(null);
            var timeSpan = AU.maps.helpers.getCurrentTime().replace(':', '') - AU.maps.building.departureTimes[i].replace(':', '');
            if (timeSpan >= 0 && !found) {
                closest = AU.maps.building.markers.overlays[i];
            } else {
                found = true;
            }
        }
        if (typeof closest !== "undefined") {
            closest.setAnimation(google.maps.Animation.BOUNCE);
        }
    },
    getNearestBusStop: function (origin, destination, date, time, arrival) {
        var oX = AU.maps.helpers.convertFromLatLng(origin.lat());
        var oY = AU.maps.helpers.convertFromLatLng(origin.lng());
        var dX = AU.maps.helpers.convertFromLatLng(destination.lat());
        var dY = AU.maps.helpers.convertFromLatLng(destination.lng());
        var max = 1;

        var oId;
        var dId;
        var source = this.data.source.stopsNearby.replace('{0}', oX).replace('{1}', oY).replace('{2}', this.constants.radii.nearestBus).replace('{3}', max);
        AU.helpers.getXML(source, function (data) {
            var locations = $(data).find('StopLocation');
            if (locations.length === 1) {
                oId = $(locations[0]).attr('id');
                source = AU.maps.building.data.source.stopsNearby.replace('{0}', dX).replace('{1}', dY).replace('{2}', AU.maps.building.constants.radii.nearestBus).replace('{3}', max);
                AU.helpers.getXML(source, function (data) {
                    locations = $(data).find('StopLocation');
                    if (locations.length === 1) {
                        dId = $(locations[0]).attr('id');
                        AU.maps.building.showPublicTransportDirections(oId, dId, date, time, arrival);
                    }
                });
            }
        });
    },
    showPublicTransportDirections: function (origin, destination, date, time, arrival) {
        // Vi fjerner alle elementer i indholdsvisningen...
        var contentContainer = $('#au_maps_route_content_public');
        contentContainer.children().each(function () {
            $(this).remove();
        });

        // ...og bygger op på ny!
        $('<h1 />', {
            id: 'au_maps_building_content_header',
            html: STR_DIRECTIONS
        }).appendTo(contentContainer);

        var source = this.data.source.publicTransportRoute.replace('{0}', origin).replace('{1}', destination).replace('{2}', date).replace('{3}', time).replace('{4}', arrival ? '1' : '0');
        AU.helpers.getXML(source, function (data) {
            var tripsXML = $(data).find('Trip');
            var tripHTML = tripsXML.length > 0 ? "" : "<ul><li>" + STR_NO_PUBLIC_ROUTE + "</li></ul>";
            $.each(tripsXML, function (i, trip) {
                tripHTML += "<ol>";
                var legsXML = $(trip).find('Leg');
                $.each(legsXML, function (j, leg) {
                    var transport = $(leg).attr('name');
                    var origin = $(leg).find('Origin');
                    var oName = origin.attr('name');
                    var oTime = origin.attr('time');
                    var oDate = origin.attr('date');
                    var destination = $(leg).find('Destination');
                    var dName = destination.attr('name');
                    var dTime = destination.attr('time');
                    var dDate = destination.attr('date');
                    tripHTML += "<li>" + oName + ", <strong>" + oDate + " " + oTime + "</strong> &raquo; " + dName + ", <strong>" + dDate + " " + dTime + "</strong> (<strong>" + transport + "</strong>)</li>";
                });
                tripHTML += "</ol>";
                tripHTML += "<hr />";
            });

            $(tripHTML).appendTo(contentContainer);


        });

        contentContainer.show();
        $('#au_maps_content_trigger').trigger('click');
        AU.maps.building.disableRoutes();
    },
    getNearestBuilding: function (point, radius) {
        var minimumDistance = 0;
        var tempDistance;
        var buildingPoint;
        var nearestBuilding;

        // Vi løber alle bygninger igennem
        for (var i = 0; i < this.data.locations.length; i++) {
            if (this.data.locations[i].type === AU.maps.building.constants.BUILDING) {
                buildingPoint = new google.maps.LatLng(this.data.locations[i].latitude, this.data.locations[i].longitude);
                // Afstanden mellem klik-punkt og bygning beregnes vha. geometry library (som er inkluderet i headeren)
                tempDistance = AU.maps.helpers.getDistanceBetweenPoints(point, buildingPoint);

                // Hvis afstanden er mindre end den hidtidige mindste afstand...
                if (tempDistance < minimumDistance || minimumDistance === 0) {
                    minimumDistance = tempDistance;
                    nearestBuilding = this.data.locations[i];
                }
            }
        }

        if (minimumDistance > radius) {
            return null;
        }

        return nearestBuilding;
    },
    getBuilding: function (number) {
        var building = null;
        for (var i = 0; i < this.data.locations.length; i++) {
            if (this.data.locations[i].type === this.constants.BUILDING && this.data.locations[i].id === number.toString()) {
                building = this.data.locations[i];
                break;
            }
        }
        return building;
    },
    getDepartment: function (departmentId) {
        var department = null;
        for (var i = 0; i < this.data.locations.length; i++) {
            if (this.data.locations[i].type === this.constants.DEPARTMENT && this.data.locations[i].id === departmentId.toString()) {
                department = this.data.locations[i];
                break;
            }
        }
        return department;
    },
    getDepartments: function (xml) {
        var departments = [];

        var departmentsXML = $(xml).find('department');

        $.each(departmentsXML, function (i, d) {
            var id = $(d).attr('uuid');
            var name = $(d).attr('name');
            var details = $(d).find('details');
            var detailsSource = details.attr('external');

            var department = {
                id: id,
                name: name,
                detailsSource: detailsSource
            };

            departments[i] = department;
        });

        return departments;
    },
    getOverlay: function (id) {
        var place;
        for (var i = 0; i < this.data.locations.length; i++) {
            if (this.data.locations[i].type === this.constants.OVERLAY && this.data.locations[i].id === id.toString()) {
                place = this.data.locations[i];
            }
        }
        return place;
    },
    disableOverlays: function () {
        $('#au_maps_overlay_container .button:not(.disabled)').addClass('disabled');
        this.setOverlays();
    },
    disableRoutes: function () {
        $('#au_maps_route_content').hide();
        AU.maps.route.directionsDisplay.setMap(null);
    },
    setAltLanguageHref: function (queryAttr) {
        var chgLang = $('#header #au_language_selection a');
        if (chgLang.length > 0) {
            var chgLangHref = chgLang.attr('href').split('?')[0];
            chgLang.attr('href', chgLangHref + queryAttr);
        }
    }
};

if (!window.deferLoading) {

    AU.ready.push(function () {

        AU.maps.building.options.image = 'https://cdn.au.dk/2011/maps/graphics/marker_generic.png';

        var constants = AU.maps.building.constants;
        AU.maps.building.center = new google.maps.LatLng(constants.centerLat, constants.centerLng);
        AU.maps.building.markers.icon = new google.maps.MarkerImage(AU.maps.building.options.image, null, null, null, new google.maps.Size(constants.markerWidth, constants.markerHeight));
        AU.maps.building.setKeyEvents();

        AU.maps.building.mapContainer = document.getElementById('au_map');
        AU.maps.building.getData();
    });

}

AU.resize.push(function () {
    if (AU.maps.building.markers.locations.length > 0) {
        AU.maps.building.map.setCenter(AU.maps.building.markers.locations[0].position);
    }
});